import { render, staticRenderFns } from "./ImageDance.vue?vue&type=template&id=7035f719&scoped=true"
import script from "./ImageDance.vue?vue&type=script&lang=js"
export * from "./ImageDance.vue?vue&type=script&lang=js"
import style0 from "./ImageDance.vue?vue&type=style&index=0&id=7035f719&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7035f719",
  null
  
)

export default component.exports